import { Scorecard } from '../../entities/applicant_tracking/Scorecard';

export function calcScorecardAverage(scorecard: Scorecard): number {
  const answeredQuestions = scorecard.survey?.answers?.filter((answer) => {
    return answer.value;
  });

  return answeredQuestions?.reduce(function (avg, answer, _, { length }) {
    return avg + parseInt(answer.value as string, 10) / length;
  }, 0);
}
